export enum IndicadorServicio {
   "BoletasServicioPeriodico" = 1,
   "BoletasServicioPeriodicoDomiciliario" = 2,
   "BoletasVentaYServicios" = 3,
   "BoletaEspectaculoEmitidaTerceros" = 4,
}

export enum IndicadorServicioExportacion {
   "Sin Especificar" = 0,
   "Hoteleria" = 4,
   "Transporte Terrestre Internacional" = 5,
}